<table class="cliente-analise-mercado-cliente-table table table-striped table-hover table-bordered" [id]="idDataTable">
    <thead>
        <tr class="first-row">
            <th class="col-options text-center row-span-2" rowspan="2"></th>
            <th class="col-nome-cliente row-span-2" rowspan="2">Cliente</th>
            <th class="col-cadastro-cliente text-center row-span-2" rowspan="2">Cadastro</th>
            <th class="col-situacao-cliente text-center row-span-2" rowspan="2">Situação</th>
            <th class="col-nome-classificacao-rap row-span-2" rowspan="2" title="Classificação {{KPI_RAP.nome}}" *ngIf="isShowClassificaoRAP">Classificação {{KPI_RAP.sigla}}</th>
            <th class="col-customer-share text-center row-span-2" rowspan="2" *ngIf="isShowCustomerShare" [title]="KPI_CUSTOMER_SHARE.nome">{{KPI_CUSTOMER_SHARE.nome}} {{KPI_RAP.sigla}}</th>
            <th class="col-customer-share text-center row-span-2" rowspan="2" *ngIf="isShowCustomerShare" [title]="KPI_CUSTOMER_SHARE.nome">{{KPI_CUSTOMER_SHARE.nome}} {{KPI_RAR.sigla}}</th>
            <th colspan="3" class="col-quantidade text-center" *ngIf="controleQuantidade">Quantidade</th>
            <th colspan="3" class="col-peso text-center" *ngIf="controlePeso">Peso</th>
            <th colspan="3" class="col-valor text-center" *ngIf="controleValor">Valor</th>
        </tr>
        <tr class="second-row">
            <!-- Quantidade -->
            <ng-template [ngIf]="controleQuantidade">
                <th class="col-quantidade col-quantidade-potencial text-right" title="Quantidade Sell In Cliente">Sell In Cliente</th>
                <th class="col-quantidade col-quantidade-pretendida text-right" title="Quantidade Pretendida">Pretendida</th>
                <th class="col-quantidade col-quantidade-realizada text-right" title="Quantidade Realizada">Realizada</th>
            </ng-template>

            <!-- Peso -->
            <ng-template [ngIf]="controlePeso">
                <th class="col-peso col-peso-potencial text-right" title="Peso Sell In Cliente">Sell In Cliente</th>
                <th class="col-peso col-peso-pretendido text-right" title="Peso Pretendido">Pretendido</th>
                <th class="col-peso col-peso-realizado text-right" title="Peso Realizado">Realizado</th>
            </ng-template>

            <!-- Valor -->
            <ng-template [ngIf]="controleValor">
                <th class="col-valor col-valor-potencial text-right" title="Valor Sell In Cliente">Sell In Cliente</th>
                <th class="col-valor col-valor-pretendido text-right" title="Valor Pretendido">Pretendido</th>
                <th class="col-valor col-valor-realizado text-right" title="Valor Realizada">Realizado</th>
            </ng-template>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let cliente of clientes">
            <td class="col-options text-center">
                <span class="btn-group dropup table-options" sgtDropdownContainerBody *ngIf="cliente.options">
                    <button type="button" title="Opções" class="btn btn-link btn-options dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                    <div class="dropdown-menu">
                        <ng-template [ngIf]="cliente.options.hasOptionsAnaliseMercado()">
                            <h6 class="dropdown-header">Análise de Mercado</h6>
                            <a class="dropdown-item" *ngIf="cliente.options.canOpenAnaliseMercado" (click)="openAnaliseMercado.emit(cliente)">
                                Abrir Análise
                            </a>                                                                          
                        </ng-template>
                        
                        <ng-template [ngIf]="cliente.options.hasOptionsCliente()">
                            <div class="dropdown-divider"></div>
                            <h6 class="dropdown-header">Cliente</h6>
                            <a class="dropdown-item" *ngIf="cliente.options.canOpenCliente" (click)="openCliente.emit(cliente)">
                                Abrir Cadastro
                            </a>      
                            <a class="dropdown-item dropdown-item-prebaixar" *ngIf="cliente.options.canPreBaixarCliente" (click)="preBaixarCliente.emit(cliente)">
                                Pré-Baixar Cliente
                            </a>   
                            <a class="dropdown-item dropdown-item-baixar" *ngIf="cliente.options.canBaixarCliente" (click)="baixarCliente.emit(cliente)">
                                Baixar Cliente
                            </a>                                                                                       
                        </ng-template>

                        <ng-template [ngIf]="cliente.options.hasOptionsCentralCompra()">
                            <div class="dropdown-divider"></div>
                            <h6 class="dropdown-header">Central de Compras</h6>
                            <a class="dropdown-item" *ngIf="cliente.options.canInsertCentralCompra" (click)="insertCentralCompra.emit()">
                                Adicionar Central de Compras
                            </a>   
                            <a class="dropdown-item" *ngIf="cliente.options.canEditCentralCompra" (click)="editCentralCompra.emit(cliente)">
                                Atualizar Central de Compras
                            </a>  
                            <a class="dropdown-item" *ngIf="cliente.options.canInsertParticipanteCentralCompra" (click)="insertParticipanteCentralCompra.emit(cliente)">
                                Adicionar Como Participante
                            </a>                                                                                           
                        </ng-template>
                    </div>
                </span>                    
            </td>
            <td class="col-nome-cliente">
                {{cliente.nomeCliente | clienteNome: cliente.nomeFantasiaCliente:cliente.codigoIntegracaoErpCliente:cliente.tipoPessoa}}
                <br/>
                <small>{{cliente.nomeCliente | clienteNomeSecundario: cliente.nomeFantasiaCliente}}</small>
            </td>

            <td class="col-cadastro-cliente text-center" title="{{cliente.cadastro | clienteCadastro}}">
                <span class="{{cliente.cadastro | clienteCadastroBadge}}">{{cliente.cadastro | clienteCadastro}}</span>
            </td>

            <td class="col-situacao-cliente text-center" title="{{cliente.situacao | clienteSituacao}}">
                <span class="{{cliente.situacao | clienteSituacaoBadge}}">{{cliente.situacao | clienteSituacao}}</span>
            </td>            

            <td class="col-nome-classificacao-rap" [title]="cliente.nomeClassificacaoRAP ? cliente.nomeClassificacaoRAP : ''" *ngIf="isShowClassificaoRAP">
                {{cliente.nomeClassificacaoRAP}}
            </td>   
            
            <td class="col-customer-share text-center" *ngIf="isShowCustomerShare">
                <sgt-customer-share-indicador-badge
                    [indicador]="cliente.indicadorCustomerSharePretendido"
                    [perc]="cliente.valorPretendidoPerc"
                    [percMinIntegerDigits]="1"
                    [percMinFractionDigits]="0"
                    [percMaxFractionDigits]="0"
                    fontSize="8px">
                </sgt-customer-share-indicador-badge>
            </td>
            
            <td class="col-customer-share text-center" *ngIf="isShowCustomerShare">
                <sgt-customer-share-indicador-badge
                    [indicador]="cliente.indicadorCustomerShareRealizado"
                    [perc]="cliente.valorRealizadoPerc"
                    [percMinIntegerDigits]="1"
                    [percMinFractionDigits]="0"
                    [percMaxFractionDigits]="0"
                    fontSize="8px">
                </sgt-customer-share-indicador-badge>
            </td>            

            <!-- Quantidade -->
            <ng-template [ngIf]="controleQuantidade">
                <td class="col-quantidade col-quantidade-potencial text-right">
                    {{cliente.quantidadePotencial | decimalFormat: 1:0:0}}
                </td>
                <td class="col-quantidade col-quantidade-pretendida text-right">
                    {{cliente.quantidadePretendida | decimalFormat: 1:0:0}}
                </td>
                <td class="col-quantidade col-quantidade-realizada text-right">
                    {{cliente.quantidadeRealizada | decimalFormat: 1:0:0}}
                </td>
            </ng-template>

            <!-- Peso -->
            <ng-template [ngIf]="controlePeso">
                <td class="col-peso col-peso-potencial text-right">
                    {{cliente.pesoPotencial | decimalFormat: 1:0:0}}
                </td>
                <td class="col-peso col-peso-pretendido text-right">
                    {{cliente.pesoPretendido | decimalFormat: 1:0:0}}
                </td>
                <td class="col-peso col-peso-realizado text-right">
                    {{cliente.pesoRealizado | decimalFormat: 1:0:0}}
                </td>
            </ng-template>

            <!-- Valor -->
            <ng-template [ngIf]="controleValor">
                <td class="col-valor col-valor-potencial text-right">
                    {{cliente.valorPotencial | decimalFormat: 1:0:0}}
                </td>
                <td class="col-valor col-valor-pretendido text-right">
                    {{cliente.valorPretendido | decimalFormat: 1:0:0}}
                </td>
                <td class="col-valor col-valor-realizado text-right">
                    {{cliente.valorRealizado | decimalFormat: 1:0:0}}
                </td>
            </ng-template>
        </tr>
        <tr *ngIf="quantidadeClientes === 0">
            <td class="text-center" colspan="100">
                <i class='fas fa-info' aria-hidden='true'></i> Nenhum Cliente Encontrado
            </td>
        </tr>
    </tbody>
    <tfoot>
        <tr>
            <td [attr.colspan]="dataTableFooterColspan" class="text-center col-quantidade-clientes">
                {{quantidadeClientes | decimalFormat: 1:0:0}} cliente(s)
            </td>

            <td class="col-customer-share text-center" *ngIf="isShowCustomerShare">
                <sgt-customer-share-indicador-badge
                    [indicador]="total?.indicadorCustomerSharePretendido"
                    [perc]="total?.valorPretendidoPerc"
                    [percMinIntegerDigits]="1"
                    [percMinFractionDigits]="0"
                    [percMaxFractionDigits]="0"
                    fontSize="8px">
                </sgt-customer-share-indicador-badge>
            </td>  
            
            <td class="col-customer-share text-center" *ngIf="isShowCustomerShare">
                <sgt-customer-share-indicador-badge
                    [indicador]="total?.indicadorCustomerShareRealizado"
                    [perc]="total?.valorRealizadoPerc"
                    [percMinIntegerDigits]="1"
                    [percMinFractionDigits]="0"
                    [percMaxFractionDigits]="0"
                    fontSize="8px">
                </sgt-customer-share-indicador-badge>
            </td>              

            <!-- Quantidade -->
            <ng-template [ngIf]="controleQuantidade">
                <td class="col-quantidade col-quantidade-potencial text-right">
                    {{total?.quantidadePotencial | decimalFormat: 1:0:0}}
                </td>                
                <td class="col-quantidade col-quantidade-pretendida text-right">
                    {{total?.quantidadePretendida | decimalFormat: 1:0:0}}

                    <!-- <sgt-table-perc-progress
                        [perc]="total?.quantidadePretendidaPerc">
                    </sgt-table-perc-progress>                     -->
                </td>              
                <td class="col-quantidade col-quantidade-realizada text-right">
                    {{total?.quantidadeRealizada | decimalFormat: 1:0:0}}

                    <!-- <sgt-table-perc-progress
                        [perc]="total?.quantidadeRealizadaPercPretendida">
                    </sgt-table-perc-progress>                    -->
                </td>   
            </ng-template>
            
            <!-- Peso -->
            <ng-template [ngIf]="controlePeso">
                <td class="col-peso col-peso-potencial text-right">
                    {{total?.pesoPotencial | decimalFormat: 1:0:0}}
                </td>                
                <td class="col-peso col-peso-pretendido text-right">
                    {{total?.pesoPretendido | decimalFormat: 1:0:0}}

                    <!-- <sgt-table-perc-progress
                        [perc]="total?.pesoPretendidoPerc">
                    </sgt-table-perc-progress>                     -->
                </td>            
                <td class="col-peso col-peso-realizado text-right">
                    {{total?.pesoRealizado | decimalFormat: 1:0:0}}

                    <!-- <sgt-table-perc-progress
                        [perc]="total?.pesoRealizadoPercPretendido">
                    </sgt-table-perc-progress>                   -->
                </td> 
            </ng-template>
            
            <!-- Valor -->
            <ng-template [ngIf]="controleValor">
                <td class="col-valor col-valor-potencial text-right">
                    {{total?.valorPotencial | decimalFormat: 1:0:0}}
                </td>                 
                <td class="col-valor col-valor-pretendido text-right">
                    {{total?.valorPretendido | decimalFormat: 1:0:0}}
    
                    <!-- <sgt-table-perc-progress
                        [perc]="total?.valorPretendidoPerc">
                    </sgt-table-perc-progress>                    -->
                </td>  
                <td class="col-valor col-valor-realizado text-right">
                    {{total?.valorRealizado | decimalFormat: 1:0:0}}
    
                    <!-- <sgt-table-perc-progress
                        [perc]="total?.valorRealizadoPercPretendido">
                    </sgt-table-perc-progress>                   -->
                </td>                                  
            </ng-template>            
        </tr>
    </tfoot>
</table>